import { gql } from '@apollo/client';

export const CREATE_METRIC_GROUP_MUTATOR = gql`
  mutation createMetricGroupMutator(
    $master_list: Boolean
    $metric_group: JSON
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    createMetricGroup(
      master_list: $master_list
      metric_group: $metric_group
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const UPDATE_METRIC_GROUP_MUTATOR = gql`
  mutation createMetricGroupMutator(
    $master_list: Boolean
    $updated_metric_group: JSON
    $original_metric_group: JSON
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    updateMetricGroup(
      master_list: $master_list
      updated_metric_group: $updated_metric_group
      original_metric_group: $original_metric_group
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const DELETE_METRIC_GROUP_WITH_METRICS_MUTATOR = gql`
  mutation createMetricGroupMutator(
    $master_list: Boolean
    $metric_group_id: String
    $group_id: String
    $company_id: String
  ) {
    deleteMetricGroupWithMetrics(
      master_list: $master_list
      metric_group_id: $metric_group_id
      group_id: $group_id
      company_id: $company_id
    )
  }
`;
